<div class="addNewPolicyContainer">


  <div class="Loading" *ngIf="isShowLoading">
    <div class="loader"></div>
    <label class="loaderlabel">Please wait while Processing....</label>
  </div>

  <div class="Clears"></div>
</div>

<div class="container-fluid" oncontextmenu="return false" oncopy="return false" onpaste="return false" oncut="return false">
  <div class="MyProposalForm disForm seoLandingPage">
    <div class="col-lg-5 col-md-5 hidden-sm hidden-xs">
      <div class="car_bg">
        <div class="Description">
          <img src="assets/theme/en/images/1.jpg">
          <h3>{{'Travel Insurance'|translate}}</h3>
          <div class="row" style="display: flex;justify-content:center;">
            <span *ngIf="Lng=='en'" class="glyphicon glyphicon-question-sign field-tip-travellogo">
              <span class="tip-content" [innerHTML]="TravelLogoTooltip"></span>
            </span>
            <span *ngIf="Lng=='ar'" class="glyphicon glyphicon-question-sign field-tip-travellogoAr">
              <span class="tip-contentAr" [innerHTML]="TravelLogoTooltip"></span>
            </span>
          </div>
        </div>
        <i class="fa fa-angle-right arrows"></i>
      </div>
    </div>
    <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 InsuredForm">
      <form #NewTravelPolicyForm="ngForm">
        <div class="CarForm">
          <div class="InsuredInformation Infomation">
            <div class="FormSection">
              <div class="Clears"></div>


              <div class="Field">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label class="lbltext">{{'Travel Plan'|translate}}</label>
                  </div>
                  <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                    <select class="form-control" id="txtDestination" name="txtDestination" required [(ngModel)]="travelBindObj.propoalObj.ZoneCode" #txtDestination="ngModel">
                      <option disabled value="">{{'Select Plan'|translate}}</option>
                      <option *ngFor="let Zone of travelBindObj.zoneList" [value]="Zone.ZoneCode">
                        {{ Lng=="en"?Zone.ZoneDescEn:Zone.ZoneDescAr }}</option>
                    </select>
                    <span *ngIf="txtDestination.invalid && (txtDestination.dirty)" class="text-danger">
                      <div *ngIf="txtDestination.errors?.required">
                        {{'Destination is required'|translate}}
                      </div>
                    </span>
                  </div>
                </div>
              </div>

              <!-- <div class="Field">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label class="lbltext">{{'Plan Type'|translate}}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <select class="form-control" id="txtPlan" name="txtPlan" required
                                            [(ngModel)]="travelBindObj.propoalObj.PlanCode" #txtPlan="ngModel">
                                            <option value="">{{'Select Plan Type'|translate}}</option>
                                            <option *ngFor="let plan of travelBindObj.planList" [value]="plan.PlanCode">
                                                {{ Lng=="en"?plan.PlanDescEn:plan.PlanDescAr  }}</option>
                                        </select>
                                        <span *ngIf="txtPlan.invalid && (txtPlan.dirty)" class="text-danger">
                                            <div *ngIf="txtPlan.errors?.required">
                                                {{'Plan is required'|translate}}
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div> -->

              <div class="Field" *ngIf="false">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label class="lbltext">{{'Departure Airport'|translate}}</label>
                  </div>
                  <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                    <div class="form-control" style="width:100%;">
                      <div (click)="myFunction('myDepartureDropdown')" class="dropbtn" style="width: 100%;">
                        <button style="border: none; background: none;" class="selectAirport" id="optionDeparture">--{{'Select'|translate}}--</button>
                      </div>

                    </div>
                    <div id="myDepartureDropdown" class="form-control" style="position: relative;height: 180px;overflow: auto;">
                      <input type="text" placeholder="Search.." name="Departure" [(ngModel)]="searchAir" class="form-control" id="myDepartureInput" (keydown)="filterFunction('myDepartureInput','myDepartureDropdown')">
                      <option style="padding: 7px 3px;" class="itemAirport" *ngFor="let airport of travelBindObj.destList" [value]="travelBindObj.propoalObj.DepartureAirport" (click)="getDepartureValue(airport)">
                        {{ Lng=="en"? airport.DestinationNameEn :airport.DestinationNameAr }}</option>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 

                            <div class="Field">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label class="lbltext">{{'Departure Airport'|translate}}</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                        <input type="text" id="txtDeparture" name="txtDeparture"  class="form-control"
                                            [(ngModel)]="travelBindObj.propoalObj.DepartureAirport" #txtDeparture="ngModel" required
                                            autocomplete="off">
                                        <span *ngIf="txtDeparture.invalid && (txtDeparture.dirty )" class="text-danger">
                                            <div *ngIf="txtDeparture.errors.required">
                                                {{'Departure Airport is required.'|translate}}
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div> -->

              <div class="Field" *ngIf="false">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label class="lbltext">{{'Transit Airport'|translate}}</label>
                  </div>
                  <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                    <input type="text" id="txtTransit" name="txtTransit" class="form-control" [(ngModel)]="travelBindObj.propoalObj.TransitAirport" #txtTransit="ngModel" autocomplete="off">
                    <!-- <span *ngIf="txtTransit.invalid && (txtTransit.dirty )" class="text-danger">
                                            <div *ngIf="txtTransit.errors.required">
                                                {{'Transit Airport is required.'|translate}}
                                            </div>
                                        </span> -->
                  </div>
                </div>
              </div>

              <div class="Field">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label class="lbltext">{{'Destination Country'|translate}}</label>
                  </div>
                  <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                    <input type="text" id="txtDestinationAirport" name="txtDestinationAirport" class="form-control" [(ngModel)]="travelBindObj.propoalObj.DestinationAirport" #txtDestinationAirport="ngModel" required autocomplete="off">
                    <span *ngIf="txtDestinationAirport.invalid && (txtDestinationAirport.dirty )" class="text-danger">
                      <div *ngIf="txtDestinationAirport.errors.required">
                        {{'Destination Country is required.'|translate}}
                      </div>
                    </span>
                  </div>
                </div>
              </div>



              <div class="Field">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label class="lbltext">{{'Travel From'|translate}}</label>
                  </div>
                  <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                    <input type="text" id="txtFrom" name="txtFrom" bsDatepicker class="form-control" [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' }" [(ngModel)]="travelBindObj.propoalObj.TravelFrom" #txtFrom="ngModel" [minDate]="minDate" (ngModelChange)="CalculateFromDays('FromDate')" required autocomplete="off">
                    <span *ngIf="txtFrom.invalid && (txtFrom.dirty )" class="text-danger">
                      <div *ngIf="txtFrom.errors.required">
                        {{'Travel From is required.'|translate}}
                      </div>
                    </span>
                  </div>
                </div>
              </div>


              <div class="Field">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label class="lbltext">{{'Travel To'|translate}}</label>
                  </div>
                  <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                    <input type="text" id="txtTo" name="txtTo" class="form-control" bsDatepicker class="form-control" [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' }" [(ngModel)]="travelBindObj.propoalObj.TravelTo" #txtTo="ngModel" [minDate]="minDate" (ngModelChange)="CalculateDays('ToDate')" required autocomplete="off" [maxDate]="maxDate">
                    <span *ngIf="txtTo.invalid && (txtTo.dirty )" class="text-danger">
                      <div *ngIf="txtTo.errors.required">
                        {{'Travel To is required.'|translate}}
                      </div>
                    </span>
                  </div>
                </div>
              </div>
              <div class="Field">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label class="lbltext">{{'Number of Days'|translate}}</label>
                  </div>
                  <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                    <input type="text" id="txtNoOfDays" name="txtNoOfDays" class="form-control" [disabled]="true" [(ngModel)]="travelBindObj.propoalObj.NoofDays" #txtNoOfDays="ngModel">
                    <span *ngIf="txtNoOfDays.invalid && (txtNoOfDays.dirty )" class="text-danger">
                      <div *ngIf="txtNoOfDays.errors.required">
                        {{'No Of Days is required'|translate}}
                      </div>
                    </span>
                  </div>
                </div>
              </div>
              <div class="Field">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label class="lbltext">{{'Insured Type'|translate}}</label>
                  </div>
                  <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                    <select class="form-control" id="txtInsuranceType" name="txtInsuranceType" required [(ngModel)]="travelBindObj.propoalObj.InsuranceType" #txtInsuranceType="ngModel" (change)="Individual()">
                      <option disabled value="">{{'Select Insured Type'|translate}}</option>
                      <option *ngFor="let ins of travelBindObj.insTypeList" [value]="ins.InsuredTypeCode">
                        {{ Lng=="en"?ins.InsuredTypeDescEn:ins.InsuredTypeDescAr }}</option>
                    </select>
                    <span *ngIf="txtInsuranceType.invalid && (txtInsuranceType.dirty )" class="text-danger">
                      <div *ngIf="txtInsuranceType.errors.required">
                        {{ 'Insured Type is required'| translate}}
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Family Grid -->
            <div class="FamilyGrid" *ngIf="travelBindObj.propoalObj.InsuranceType=='2'">
              <div class="panel panel-default panel-table">
                <div class="panel-heading">
                  <div class="row">
                    <div class="col col-xs-6">
                      <h3 class="panel-title">{{'Family Members'|translate}}</h3>
                    </div>
                    <div class="col col-xs-6 text-right">
                      <a type="button" class="btn btn-sm btn-primary btn-create" (click)="FamilyModal()">{{'Add Family Member'|translate}}</a>
                    </div>
                  </div>
                </div>
                <div class="panel-body">
                  <table class="table table-striped table-bordered table-list">
                    <thead>
                      <tr>
                        <th>{{'Name'|translate}}</th>
                        <th>{{'Passport No'|translate}}</th>
                        <th>{{'ID Number'|translate}}</th>
                        <th>{{'Relation'|translate}}</th>
                        <th>{{'DOB'|translate}}</th>
                        <th>{{'Nationality'|translate}}</th>
                        <th>{{'Action'|translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor=" let pass of travelBindObj.propoalObj.passList">
                        <td>{{pass.NAME}}</td>
                        <td>{{pass.PassportNo}}</td>
                        <td>{{pass.IdentityNo}}</td>
                        <td>{{pass.RelationShipEn}}</td>
                        <td>{{pass.DOB | date: 'dd/MM/yyyy' }}</td>
                        <td *ngIf="Lng=='en'">{{pass.NatEn}}</td>
                        <td *ngIf="Lng=='ar'">{{pass.NatAr}}</td>
                        <td>
                          <!-- <button class="btn btn-primary"
                                                        (click)="DeleteMember(pass)">{{'Delete' | translate }}</button>
                                                        <button class="btn btn-primary" (click)="EditMember(pass)">{{'Edit' | translate }}</button> -->

                          <a style="color: #20559e; text-decoration: underline;font-size: 12px;" onMouseOver="this.style.color='red'" onMouseOut="this.style.color='#20559e'" (click)="DeleteMember(pass)">{{'Delete'| translate}}</a>

                          <a style="color: #20559e; text-decoration: underline;font-size: 12px;" onMouseOver="this.style.color='#20559e'" onMouseOut="this.style.color='#20559e'" (click)="EditMember(pass)">{{'Edit'| translate}}</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="Clears"></div>
            <!-- Button Actions -->
            <div class="Actionsection">
              <div class="Actions">
                <div class="btn-group">
                  <button type="button" name="txtBUY" id="txtBUY" class="btn btn-primary btns" [disabled]="!NewTravelPolicyForm.valid || HasSaudiAddress==false" (click)="BUYPolicy(NewTravelPolicyForm.valid)">{{'Proceed'|translate}}</button>
                </div>
              </div>
            </div>
            <div class="Clears"></div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="PayMethods">
  <!-- <img src="assets/img/payment-footer-en.png"> -->
  <img src="assets/img/payment-footer-en1.png">
</div>
<!-- Family Addition Modal -->
<div class="modal InsuredForm" id="FamilyAdd" role="dialog" [ngClass]="{'fade in':modal}">
  <div class="modal-dialog modal-lg Field">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" (click)="closemodal()">&times;</button>
        <h4 class="modal-title">{{'Add Member'|translate}}</h4>
      </div>
      <div class="modal-body">
        <div class="FamilyMemberForm">
          <form #passFrm="ngForm">
            <div class="row" style="margin-bottom: 25px;">
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <label class="lbltext">{{'NAME as Per Passport'|translate}}</label>
                <input type="text" class="form-control" id="txtName" name="txtName" [(ngModel)]="passObj.NAME" #txtName="ngModel" required autocomplete="off" pattern="[a-zA-Z ]*$" />
                <span *ngIf="txtName.invalid && (txtName.dirty )" class="text-danger valid">
                  <div *ngIf="txtName.errors.required">
                    {{'Name is required.'|translate}}
                  </div>
                  <div *ngIf="txtName.errors?.pattern">
                    {{'Name must Be In English'| translate }}
                  </div>
                </span>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <label class="lbltext">{{'PassPort'|translate}}</label>
                <input type="text" class="form-control" id="txtPassport" name="txtPassport" [(ngModel)]="passObj.PassportNo" #txtPassport="ngModel" required autocomplete="off" (keypress)="ValidatePassportNo($event)" />
                <span *ngIf="txtPassport.invalid && (txtPassport.dirty )" class="text-danger valid">
                  <div *ngIf="txtPassport.errors.required">
                    {{'Passport No is required'|translate}}
                  </div>
                </span>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <label class="lbltext">{{'ID Number'|translate}}</label>
                <input type="text" class="form-control" id="txtIQama" name="txtIQama" autocomplete="off" [(ngModel)]="passObj.IdentityNo" #txtIQama="ngModel" required (ngModelChange)="ValidateIdentityNo($event)" minlength="10" maxlength="10" pattern="^[1,2,3][0-9]*" numbersOnly />
                <span *ngIf="txtIQama.invalid && (txtIQama.dirty || txtIQama.touched)" class="text-danger valid">
                  <div *ngIf="txtIQama.errors.required">
                    {{'ID Number is required'|translate}}
                  </div>
                  <div [hidden]="!txtIQama.hasError('pattern')">
                    {{'ID Number Must Start with 1,2 or 3'| translate }}</div>
                  <div *ngIf="txtIQama.errors?.minlength">
                    {{'ID Number must be 10 digits'| translate }}
                  </div>
                  <div *ngIf="txtIQama.errors?.maxlength">
                    {{'ID Number must be 10 digits'| translate }}
                  </div>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <label class="lbltext">{{'DOB'|translate}}</label>
                <input type="text" class="form-control" id="txtDOB" name="txtDOB" autocomplete="off" bsDatepicker [(ngModel)]="passObj.DOB" #txtDOB="ngModel" [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' }" required [maxDate]="DoBmaxDate" (blur)="ValidateDOB($event.target.value)">
                <span style="position: absolute;" *ngIf="txtDOB.invalid && (txtDOB.dirty )" class="text-danger valid">
                  <div *ngIf="txtDOB.errors.required">
                    {{'DOB is required'|translate}}
                  </div>
                </span>
                <!-- <input type="text" class="form-control" id="txtDOBHijri" name="txtDOBHijri" autocomplete="off" HijriPicker [(ngModel)]="passObj.DOB" #txtDOBHijri="ngModel" 
									required  (blur)="ValidateDOB($event.target.value)" type='HijriPicker'>
									<span *ngIf="txtDOBHijri.invalid && (txtDOBHijri.dirty || isSubmitted)" class="text-danger valid">
									    <div *ngIf="txtDOBHijri.errors.required">
									       {{'DOB is required'|translate}}
									    </div>
									</span> -->
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <label class="lbltext">{{'Relation'|translate}}</label>
                <select class="form-control" id="txtRelation" name="txtRelation" autocomplete="off" [(ngModel)]="passObj.RelationShip" #txtRelation="ngModel" required>
                  <option value="">{{'Select Relation'|translate}}</option>
                  <option *ngFor="let r of travelBindObj.relList" [value]="r.RelationID">
                    {{ Lng=="en"? r.RelationNameEn :r.RelationNameAr }}</option>
                </select>
                <span *ngIf="txtRelation.invalid && (txtRelation.dirty )" class="text-danger valid">
                  <div *ngIf="txtRelation.errors.required">
                    {{'Relation is required'|translate}}
                  </div>
                </span>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <label class="lbltext">{{'Nationality'|translate}}</label>
                <select class="form-control" id="txtNat" name="txtNat" autocomplete="off" [(ngModel)]="passObj.NationalityCode" #txtNat="ngModel" required>
                  <option value="">{{'Select Nationality'|translate}} </option>
                  <option *ngFor="let nat of travelBindObj.natList" [value]="nat.NATCode">
                    {{ Lng=="en"? nat.NATNameEn :nat.NATNameAr }}</option>
                </select>
                <span *ngIf="txtNat.invalid && (txtNat.dirty )" class="text-danger valid">
                  <div *ngIf="txtNat.errors.required">
                    {{'Nationality is required'|translate}}
                  </div>
                </span>
              </div>


              <div class="row" *ngIf="this.passObj.IdentityNo != undefined && passObj.IdentityNo.length==10">
                <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12">
                  <div class="panel panel-default" style="margin-top: 40px;">
                    <div class="panel-body">
                      <p class="text-center text-muted">
                        <i class="fa fa-camera fa-4x"></i>
                      </p>
                      <h4 class="text-center text-muted">{{ 'ID Copy' | translate }}
                        <small uib-tooltip="For New Arrivals">
                          <i class="fa fa-info-circle"></i>
                        </small>
                        <br>
                        <small>({{ 'Scan Copy' | translate}} )</small>
                      </h4>

                      <div style="position:relative;">
                        <a class="btn btn-block" href='javascript:;'>
                          <b style="color:whitesmoke">{{ 'Choose File'| translate}}...</b>
                          <input type="file" (change)="OnSelectIDCopy($event,passObj)" style='position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;' size="10" accept="image/*" />
                          <i class="fa fa-upload"></i>
                        </a>

                        <img *ngIf="passObj.IDCopy!=null" class="img-thumbnail imgdisplay" src="{{'data:image/jpg;base64,' + passObj.IDCopy}}" height="75px">

                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12">
                  <div class="panel panel-default" style="margin-top: 40px;">

                    <div class="panel-body">
                      <p class="text-center text-muted">
                        <i class="fa fa-camera fa-4x"></i>
                      </p>
                      <h4 class="text-center text-muted"> {{ 'Passport Copy' | translate }}
                        <small uib-tooltip="For New Arrivals">
                          <i class="fa fa-info-circle"></i>
                        </small>
                        <br>
                        <small>({{ 'Scan Copy' | translate}} )</small>
                      </h4>

                      <div style="position:relative;">
                        <a class="btn btn-block" href='javascript:;'>
                          <b style="color:whitesmoke">{{ 'Choose File'| translate}}...</b>
                          <input type="file" (change)="OnSelectPassportCopy($event,passObj)" style='position:absolute; z-index: 2; top: 0; left: 0; filter: alpha(opacity=0); -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; opacity: 0; background-color: transparent; color: transparent;' size="10" accept="image/*" />
                          <i class="fa fa-upload"></i>
                        </a>
                        <img *ngIf="passObj.PassportCopy!=null" class="img-thumbnail imgdisplay" src="{{'data:image/jpg;base64,' + passObj.PassportCopy}}" height="75px">

                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
            <div class="Clears"></div>
            <div class="Actionsection">
              <div class="Actions">
                <div class="btn-group">
                  <button type="button" name="Add Member" id="Add" class="btn btn-primary" (click)="AddPassanger(passFrm.valid)">{{'Add Member'|translate}}</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>




<!--- Schengen VISA Modal -->

<div class="modal fade" id="SchengenVISA" data-backdrop="static" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" style="margin-bottom: 30px !important;overflow: scroll;height: 500px;">
      <div class="modal-header" style="background-color: #004085;">
        <button type="button" class="close" data-dismiss="modal" #closeBtn>X</button>
        <h4 class="modal-title" style="color: white;font-size: 14px !important;">
          {{'Schengen VISA' | translate }}</h4>
      </div>
      <div class="modal-body">
        <table class="table table-bordered table-hover">
          <tbody>
            <tr>
              <td class="tablehead">{{'Section 1 - Personal Accident Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Principal Sum Insured' | translate}}</td>
              <td>{{'562,500 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Accidental Death' | translate}}</td>
              <td>{{'100% of the Principal Sum Insured' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Permanent Partial Disability' | translate}}</td>
              <td>{{'% of the Principal Sum Insured as per scale.' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Permanent Total Disability' | translate}}</td>
              <td>{{'100% of the Principal Sum Insured' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 2 - Medical and Related Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Medical Expenses (EME) (Accident & Sickness)' | translate}}</td>
              <td>{{'120,352 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Dental Expenses' | translate}}</td>
              <td>{{'Included in EME up to max of S.R 3,750' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Tooth' | translate}}</td>
              <td>{{'750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Medical Evacuation' | translate}}</td>
              <td>{{'Included in EME' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 3 - Travel Inconvenience Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Baggage Loss (Common Carrier)' | translate}}</td>
              <td>{{'9,375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Bag' | translate}}</td>
              <td>{{'3,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Item' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Baggage Delay' | translate}}</td>
              <td>{{'S.R 188 per hour up to S.R 3,750' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'4 Hours' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Travel Delay' | translate}}</td>
              <td>{{'S.R 188 per hour up to S.R 3,750' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'4 Hours' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Personal Liability' | translate}}</td>
              <td>{{'3,750,000 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Repatriation of Remains' | translate}}</td>
              <td>{{'Actual Expenses' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Repatriation of Insured Person by whatever means necessary – either by a regular flight if accepted by the airline or if required by a special airplane (ambulance plane for instance)' | translate}}
              </td>
              <td>{{'Actual Expenses' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Hijacking' | translate}}</td>
              <td>{{'S.R 938 per hours up to SAR 37,500' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Family Travel' | translate}}</td>
              <td>{{'9,375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Legal Fees' | translate}}</td>
              <td>{{'18,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Bail Bond' | translate}}</td>
              <td>{{'37,500 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Loss of Passport' | translate}}</td>
              <td>{{'1,875 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Trip Cancellation or Curtailment' | translate}}</td>
              <td>{{'18,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Missed Departure' | translate}}</td>
              <td>{{'3,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 4 - Secure Wallet (Children Excluded)'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Credit Card Fraud' | translate}}</td>
              <td>{{'3,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Papers (excluding Passport)' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Keys' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Mugging' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 5 - Additional Optional Coverage'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Hazardous Sports Benefits' | translate}}</td>
              <td>{{'Not covered' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Terrorism Extension' | translate}}</td>
              <td>{{'Not covered' | translate}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>




<!--- Schengen VISA VIP Modal -->

<div class="modal fade" id="SchengenVISAVIP" data-backdrop="static" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" style="margin-bottom: 30px !important;overflow: scroll;height: 500px;">
      <div class="modal-header" style="background-color: #004085;">
        <button type="button" class="close" data-dismiss="modal" #closeBtn>X</button>
        <h4 class="modal-title" style="color: white;font-size: 14px !important;">
          {{'Schengen VISA(VIP)' | translate }}</h4>
      </div>
      <div class="modal-body">
        <table class="table table-bordered table-hover">
          <tbody>
            <tr>
              <td class="tablehead">{{'Section 1 - Personal Accident Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Principal Sum Insured' | translate}}</td>
              <td>{{'562,500 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Accidental Death' | translate}}</td>
              <td>{{'100% of the Principal Sum Insured' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Permanent Partial Disability' | translate}}</td>
              <td>{{'% of the Principal Sum Insured as per scale.' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Permanent Total Disability' | translate}}</td>
              <td>{{'100% of the Principal Sum Insured' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 2 - Medical and Related Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Medical Expenses (EME) (Accident & Sickness)' | translate}}</td>
              <td>{{'187,500 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Dental Expenses' | translate}}</td>
              <td>{{'Included in EME up to max of S.R 3,750' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Tooth' | translate}}</td>
              <td>{{'750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Medical Evacuation' | translate}}</td>
              <td>{{'Included in EME' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 3 - Travel Inconvenience Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Baggage Loss (Common Carrier)' | translate}}</td>
              <td>{{'9,375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Bag' | translate}}</td>
              <td>{{'3,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Item' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Baggage Delay' | translate}}</td>
              <td>{{'S.R 188 per hour up to S.R 3,750' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'4 Hours' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Travel Delay' | translate}}</td>
              <td>{{'S.R 188 per hour up to S.R 3,750' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'4 Hours' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Personal Liability' | translate}}</td>
              <td>{{'3,750,000 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Repatriation of Remains' | translate}}</td>
              <td>{{'Actual Expenses' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Repatriation of Insured Person by whatever means necessary – either by a regular flight if accepted by the airline or if required by a special airplane (ambulance plane for instance)' | translate}}
              </td>
              <td>{{'Actual Expenses' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Hijacking' | translate}}</td>
              <td>{{'S.R 938 per hours up to SAR 37,500' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Family Travel' | translate}}</td>
              <td>{{'9,375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Legal Fees' | translate}}</td>
              <td>{{'18,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Bail Bond' | translate}}</td>
              <td>{{'37,500 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Loss of Passport' | translate}}</td>
              <td>{{'1,875 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Trip Cancellation or Curtailment' | translate}}</td>
              <td>{{'18,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Missed Departure' | translate}}</td>
              <td>{{'3,750 S.R' | translate}}-{{' 3,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 4 - Secure Wallet (Children Excluded)'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Credit Card Fraud' | translate}}</td>
              <td>{{'3,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Papers (excluding Passport)' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Keys' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Mugging' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 5 - Additional Optional Coverage'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Hazardous Sports Benefits' | translate}}</td>
              <td>{{'Not covered' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Terrorism Extension' | translate}}</td>
              <td>{{'Not covered' | translate}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


<!--- Club Plan Modal -->

<div class="modal fade" id="ClubPlan" data-backdrop="static" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" style="margin-bottom: 30px !important;overflow: scroll;height: 500px;">
      <div class="modal-header" style="background-color: #004085;">
        <button type="button" class="close" data-dismiss="modal" #closeBtn>X</button>
        <h4 class="modal-title" style="color: white;font-size: 14px !important;">{{'Club Plan' | translate }}
        </h4>
      </div>
      <div class="modal-body">
        <table class="table table-bordered table-hover">
          <tbody>
            <tr>
              <td class="tablehead">{{'Section 1 - Personal Accident Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Principal Sum Insured' | translate}}</td>
              <td>{{'93,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Accidental Death' | translate}}</td>
              <td>{{'100% of the Principal Sum Insured (Common Carrier Only)' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Permanent Partial Disability' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Permanent Total Disability' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 2 - Medical and Related Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Medical Expenses (EME) (Accident & Sickness)' | translate}}</td>
              <td>{{'187,500 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Dental Expenses' | translate}}</td>
              <td>{{'Included in EME up to max of S.R 3,750' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Tooth' | translate}}</td>
              <td>{{'750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Medical Evacuation' | translate}}</td>
              <td>{{'Included in EME' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 3 - Travel Inconvenience Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Baggage Loss (Common Carrier)' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Bag' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Item' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Baggage Delay' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Travel Delay' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Personal Liability' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Repatriation of Remains' | translate}}</td>
              <td>{{'18,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Hijacking' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Family Travel' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Legal Fees' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Bail Bond' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Loss of Passport' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Trip Cancellation or Curtailment' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Missed Departure' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 4 - Secure Wallet (Children Excluded)'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Credit Card Fraud' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Papers (excluding Passport)' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Keys' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Mugging' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 5 - Additional Optional Coverage'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Hazardous Sports Benefits' | translate}}</td>
              <td>{{'Not covered' | translate}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>



<!--- Premier Plan Modal -->

<div class="modal fade" id="PremierPlan" data-backdrop="static" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" style="margin-bottom: 30px !important;overflow: scroll;height: 500px;">
      <div class="modal-header" style="background-color: #004085;">
        <button type="button" class="close" data-dismiss="modal" #closeBtn>X</button>
        <h4 class="modal-title" style="color: white;font-size: 14px !important;">{{'Premier Plan' | translate }}
        </h4>
      </div>
      <div class="modal-body">
        <table class="table table-bordered table-hover">
          <tbody>
            <tr>
              <td class="tablehead">{{'Section 1 - Personal Accident Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Principal Sum Insured' | translate}}</td>
              <td>{{'93,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Accidental Death' | translate}}</td>
              <td>{{'100% of the Principal Sum Insured' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Permanent Partial Disability' | translate}}</td>
              <td>{{'% of the Principal Sum Insured as per scale.' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Permanent Total Disability' | translate}}</td>
              <td>{{'100% of the Principal Sum Insured' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 2 - Medical and Related Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Medical Expenses (EME) (Accident & Sickness)' | translate}}</td>
              <td>{{'375,000 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Dental Expenses' | translate}}</td>
              <td>{{'Included in EME up to max of S.R 3,750' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Tooth' | translate}}</td>
              <td>{{'750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Medical Evacuation' | translate}}</td>
              <td>{{'Included in EME' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 3 - Travel Inconvenience Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Baggage Loss (Common Carrier)' | translate}}</td>
              <td>{{'3,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Bag' | translate}}</td>
              <td>{{'1,875 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Item' | translate}}</td>
              <td>{{'188 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Baggage Delay' | translate}}</td>
              <td>{{'S.R 188 per hour up to S.R 1,875' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'4 Hours' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Travel Delay' | translate}}</td>
              <td>{{'S.R 188 per hour up to S.R 1,875' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'4 Hours' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Personal Liability' | translate}}</td>
              <td>{{'1,875,000 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Repatriation of Remains' | translate}}</td>
              <td>{{'26,250 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Hijacking' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Family Travel' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Legal Fees' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Bail Bond' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Loss of Passport' | translate}}</td>
              <td>{{'1,125 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Trip Cancellation or Curtailment' | translate}}</td>
              <td>{{'9,375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Missed Departure' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 4 - Secure Wallet (Children Excluded)'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Credit Card Fraud' | translate}}</td>
              <td>{{'1,875 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Papers (excluding Passport)' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Keys' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Mugging' | translate}}</td>
              <td>{{'NA' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 5 - Additional Optional Coverage'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Hazardous Sports Benefits' | translate}}</td>
              <td>{{'Not covered' | translate}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>




<!--- Royal Plan Modal -->

<div class="modal fade" id="RoyalPlan" data-backdrop="static" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" style="margin-bottom: 30px !important;overflow: scroll;height: 500px;">
      <div class="modal-header" style="background-color: #004085;">
        <button type="button" class="close" data-dismiss="modal" #closeBtn>X</button>
        <h4 class="modal-title" style="color: white;font-size: 14px !important;">{{'Royal Plan' | translate }}
        </h4>
      </div>
      <div class="modal-body">
        <table class="table table-bordered table-hover">
          <tbody>
            <tr>
              <td class="tablehead">{{'Section 1 - Personal Accident Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Principal Sum Insured' | translate}}</td>
              <td>{{'562,500 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Accidental Death' | translate}}</td>
              <td>{{'100% of the Principal Sum Insured' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Permanent Partial Disability' | translate}}</td>
              <td>{{'% of the Principal Sum Insured as per scale.' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Permanent Total Disability' | translate}}</td>
              <td>{{'100% of the Principal Sum Insured' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 2 - Medical and Related Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Medical Expenses (EME) (Accident & Sickness)' | translate}}</td>
              <td>{{'1,875,000 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Dental Expenses' | translate}}</td>
              <td>{{'Included in EME up to max of S.R 3,750' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Tooth' | translate}}</td>
              <td>{{'750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Medical Evacuation' | translate}}</td>
              <td>{{'Included in EME' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 3 - Travel Inconvenience Benefits'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Baggage Loss (Common Carrier)' | translate}}</td>
              <td>{{'9,375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Bag' | translate}}</td>
              <td>{{'3,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Per Item' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Baggage Delay' | translate}}</td>
              <td>{{'S.R 188 per hour up to S.R 3,750' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'4 Hours' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Travel Delay' | translate}}</td>
              <td>{{'S.R 188 per hour up to S.R 3,750' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Deductible' | translate}}</td>
              <td>{{'4 Hours' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Personal Liability' | translate}}</td>
              <td>{{'3,750,000 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Repatriation of Remains' | translate}}</td>
              <td>{{'37,500 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Hijacking' | translate}}</td>
              <td>{{'S.R 938 per hours up to SAR 37,500' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Emergency Family Travel' | translate}}</td>
              <td>{{'9,375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Legal Fees' | translate}}</td>
              <td>{{'18,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Bail Bond' | translate}}</td>
              <td>{{'37,500 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Loss of Passport' | translate}}</td>
              <td>{{'1,875 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Trip Cancellation or Curtailment' | translate}}</td>
              <td>{{'18,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Missed Departure' | translate}}</td>
              <td>{{'3,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 4 - Secure Wallet (Children Excluded)'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Credit Card Fraud' | translate}}</td>
              <td>{{'3,750 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Papers (excluding Passport)' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Keys' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td>{{'Mugging' | translate}}</td>
              <td>{{'375 S.R' | translate}}</td>
            </tr>
            <tr>
              <td class="tablehead">{{'Section 5 - Additional Optional Coverage'| translate}}</td>
              <td class="tablehead">{{'Sum Insured'| translate}}</td>
            </tr>
            <tr>
              <td>{{'Hazardous Sports Benefits' | translate}}</td>
              <td>{{'Not covered' | translate}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/TravelPortal/TraveNewProposal/TravelNewProposal.html